import React from 'react';
import { Quote as QuoteIcon, Star as StarIcon } from 'lucide-react';
const testimonials = [{
  initial: 'S',
  name: 'Sandra L.',
  detail: 'Age 57 · Phoenix, AZ',
  quote: "I've tried so many 'healthy' diets and nothing stuck. This guide is different — the recipes are so simple and I actually look forward to breakfast now. My bloating has improved dramatically in three weeks."
}, {
  initial: 'M',
  name: 'Margaret T.',
  detail: 'Age 62 · Nashville, TN',
  quote: "I was convinced I'd never lose the belly weight after menopause. Changing my breakfast was the missing piece. I've lost 11 lbs in 6 weeks and I'm eating more than I used to — just the right things."
}, {
  initial: 'D',
  name: 'Diane R.',
  detail: 'Age 54 · Denver, CO',
  quote: "The energy difference is unbelievable. I used to crash by 10am every day. Now I'm energized until lunch. My doctor even noticed improvements in my blood sugar levels at my last check-up!"
}];
export function Testimonials() {
  return <section className="bg-sand py-20 sm:py-24" data-id="element-190" data-mp="h4n6uketiff5">
      <div className="mx-auto max-w-6xl px-5 lg:px-8" data-id="element-191" data-mp="m5kn2rg9oze0">
        <div className="text-center" data-id="element-192" data-mp="m2yecohn4du7">
          <p className="eyebrow" data-id="element-193" data-mp="78a99bg5jhf4">Real women, real results</p>
          <h2 className="section-title mt-3" data-id="element-194" data-mp="79v3ezyk0ycg">What women 50+ are saying</h2>
        </div>
        <div className="mt-12 grid gap-5 lg:grid-cols-3" data-id="element-195" data-mp="c73q9dundqk1">
          {testimonials.map(testimonial => <article key={testimonial.name} className="flex flex-col rounded-2xl bg-white p-7 shadow-sm" data-id="element-196" data-mp="zyiuxd9wcjyg">
              <div className="flex gap-1 text-terracotta" aria-label="5 out of 5 stars" data-id="element-197" data-mp="q7egqfs1p34o">
                {Array.from({
              length: 5
            }).map((_, index) => <StarIcon key={index} size={15} fill="currentColor" data-id="element-198" data-mp="1itz83g8itf88" data-mpi={index} />)}
              </div>
              <QuoteIcon size={26} className="mt-6 text-sage" data-id="element-199" data-mp="1no3g82tivtaw" />
              <blockquote className="mt-3 flex-1 text-[15px] leading-7 text-forest/80" data-id="element-200" data-mp="1xgxv8z0chnh5">
                &quot;{testimonial.quote}&quot;
              </blockquote>
              <footer className="mt-7 flex items-center gap-3 border-t border-forest/10 pt-5" data-id="element-201" data-mp="1oh2gylbhtccw">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-olive text-sm font-bold text-white" data-id="element-202" data-mp="1ji7yjkhftptb">
                  {testimonial.initial}
                </span>
                <div data-id="element-203" data-mp="19seq2scldqta">
                  <p className="text-sm font-extrabold text-forest" data-id="element-204" data-mp="19rwjb1sazu74">
                    {testimonial.name}
                  </p>
                  <p className="text-xs text-forest/60" data-id="element-205" data-mp="14u4w2l2lsw99">{testimonial.detail}</p>
                </div>
              </footer>
            </article>)}
        </div>
      </div>
    </section>;
}